/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 10/26/20
 * Time: 2:54 PM
 */
export const tempCorporateHeaders = [
  {
    label: 'Logo',
    field: 'photoPath',
    sort: 'asc'
  },
  {
    label: 'Corporate Name',
    field: 'corporateName',
    sort: 'asc'
  },
  {
    label: 'Admin Name',
    field: 'fullName',
    sort: 'asc'
  },
  {
    label: 'Admin Mobile',
    field: 'adminMobile',
    sort: 'asc'
  },
  {
    label: 'Admin Email',
    field: 'adminEmail',
    sort: 'asc'
  },
  {
    label: 'Added DateTime',
    field: 'addedDate',
    sort: 'asc'
  },
  {
    label: 'Status',
    field: 'status',
    sort: 'asc'
  },
  {
    label: 'More Information',
    field: 'more',
    sort: 'asc'
  },
  ];

export const qrCheckInColumns = [
  {
    label:'No',
    field: 'key'
  },
  {
    label: 'Registration Status',
    field: 'status',
    sort: 'asc'
  },
  {
    label: 'Checked In Date & Time',
    field: 'checkedIn',
    sort: 'asc'
  },
  {
    label: 'Permission granted',
    field: 'permission',
    sort: 'asc'
  },
  {
    label: 'Visitor Identity',
    field: 'visitorIdentity',
    sort: 'asc'
  },
  {
    label: 'Visitor Mobile',
    field: 'visitorMobile',
    sort: 'asc',
  },
  {
    label: 'Name',
    field: 'visitorName',
    sort: 'asc',
  },
  {
    label: 'Address',
    field: 'address',
    sort: 'asc',
  },
  {
    label: 'City',
    field: 'city',
    sort: 'asc',
  },
  // {
  //   label: 'District',
  //   field: 'district',
  //   sort: 'asc',
  // },
  // {
  //   label: 'Purpose of Visit',
  //   field: 'visitingPurpose',
  //   sort: 'asc',
  // },
  {
    label: 'MVID',
    field: 'meetingVisitorId',
    sort: 'asc',
  },
  {
    label:'COVID Result',
    field: 'covid',
    sort: 'asc'
  }
];
export const hrViewBranchColumns = [
  {
    label: 'Branch Name',
    field: 'name',
    sort: 'asc'
  },
  {
    label: 'Address',
    field: 'address',
    sort: 'asc'
  },
  // {
  //   label: 'Location',
  //   field: 'location',
  //   sort: 'asc'
  // },
  {
    label: 'Subscription Number',
    field: 'subscription',
    sort: 'asc'
  },
  // {
  //   label: 'View',
  //   field: 'viewlocation',
  //   sort: 'asc'
  // },
  {
    label: 'Building Count',
    field: 'building_count',
    sort: 'asc'
  },
  {
    label: 'QR Code',
    field: 'qr_code',
    sort: 'asc',
  }
];
export const ivcaAllCameraColumns = [
  {
    label:'Camera ID',
    field: 'cameraId',
    sort: 'asc'
  },
  {
    label:'Branch Name',
    field: 'branchName',
    sort: 'asc'
  },
  {
    label: 'Public IP',
    field: 'cameraPublicIp',
    sort: 'asc'
  },
  {
    label: 'RTSP Port',
    field: 'rtspPort',
    sort: 'asc'
  },
  {
    label: 'RTSP URL',
    field: 'rtspUrl',
    sort: 'asc'
  },
  {
    label: 'Username',
    field: 'username',
    sort: 'asc'
  },
  {
    label: 'Suffix',
    field: 'cameraSuffix',
    sort: 'asc'
  },
  {
    label: 'Added By',
    field: 'addedBy',
    sort: 'asc'
  },
  {
    label: 'Added DateTime',
    field: 'addedDate',
    sort: 'asc'
  },
  {
    label: 'Updated By',
    field: 'updatedBy',
    sort: 'asc'
  },
  {
    label: 'Updated DateTime',
    field: 'updatedDate',
    sort: 'asc'
  },
  {
    label: 'Status',
    field: 'visitorCameraStatus',
    sort: 'asc'
  },
  {
    label: 'Actions',
    field: 'actions'
  }
];

export const uploadUsersColumns = [
  {
    label:'No',
    field: 'index',
    sort: 'asc'
  },
  {
    label:'Title',
    field: 'title',
    sort: 'asc'
  },
  {
    label: 'Gender (optional)',
    field: 'gender',
    sort: 'asc'
  },
  {
    label:'First Name',
    field: 'firstName',
    sort: 'asc'
  },
  {
    label: 'Last Name',
    field: 'lastName',
    sort: 'asc'
  },
  {
    label: 'Email',
    field: 'email',
    sort: 'asc'
  },
  {
    label: 'Mobile Number',
    field: 'mobile',
    sort: 'asc'
  },
  {
    label: 'Identification Type',
    field: 'identificationType',
    sort: 'asc'
  },
  {
    label: 'Identification Value',
    field: 'identificationValue',
    sort: 'asc'
  },

  {
    label: 'Address Line 1 (optional)',
    field: 'line1',
    sort: 'asc'
  },
  {
    label: 'Address Line 2 (optional)',
    field: 'line2',
    sort: 'asc'
  },
  {
    label: 'Province/State (optional)',
    field: 'province',
    sort: 'asc'
  },
  {
    label: 'District (optional)',
    field: 'district',
    sort: 'asc'
  },
  {
    label: 'City/Town (optional)',
    field: 'city'
  },
  {
    label: 'Zip Code (optional)',
    field: 'postalCode'
  },
  {
    label: 'Emergency Contact - Full Name (optional)',
    field: 'fullName'
  },
  {
    label: 'Emergency Contact - Mobile Number (optional)',
    field: 'emergency_mobile'
  },
  {
    label: 'Company - Emp ID',
    field: 'empId'
  },
  {
    label: 'Company - Department',
    field: 'department'
  },
  {
    label: 'Company - Designation',
    field: 'designation'
  },
  {
    label: 'Company - Budget Reference (optional)',
    field: 'budgetReferance'
  },
  {
    label: 'Company - Other Reference (optional)',
    field: 'otherReferance'
  },
  {
    label: 'Company - Extension (optional)',
    field: 'extention'
  }
];

export const ViewAllCategorizedUser = [
  {
    label:'No',
    field: 'index',
    sort: 'asc'
  },
  {
    label:'First Name',
    field: 'fName',
    sort: 'asc'
  },
  {
    label: 'Last Name',
    field: 'lName',
    sort: 'asc'
  },
  {
    label: 'Email',
    field: 'email',
    sort: 'asc'
  },
  {
    label: 'Mobile Number',
    field: 'mobile',
    sort: 'asc'
  }
];

export const ViewAllPublicUsers =
[
  {
    label: 'First Name',
    field: 'fName',
    sort: 'asc'
  },
  {
    label: 'Last Name',
    field: 'lName',
    sort: 'asc'
  },
  {
    label: 'Mobile No',
    field: 'mobile',
    sort: 'asc'
  },
  {
    label: 'Identification Type',
    field: 'idType',
    sort: 'asc'
  },
  {
    label: 'Identification Value',
    field: 'idValue',
    sort: 'asc'
  },
  {
    label: 'email',
    field: 'email',
    sort: 'asc'
  },

  {
    label: 'More Information',
    field: 'more',
    sort: 'asc'
  },
]
